<div
  class="modal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
  data-at="modal-address"
>
  <div class="modal__content">
    <div class="modal__content__header">
      <div class="navbar navbar--sub">
        <div class="navbar__section navbar__section--title">
          {{ data.title | translate }}
        </div>
        <div class="navbar__section navbar__section--right">
          <gk-icon-button icon="close" (buttonClick)="close()"></gk-icon-button>
        </div>
      </div>
    </div>
    <div class="modal__content__body">
      <gk-address-form
        *ngIf="address"
        (saveForm)="saveAddress()"
        [address]="address"
        [countyList]="countyList"
        [countryList]="countryList"
      ></gk-address-form>
    </div>
  </div>
</div>
